export default "__VITE_ASSET__0q9m2V2e__"